import { createContext, useState, useEffect } from "react";

// contexte de l'utilisateur
const UserContext = createContext();

const UserProvider = (props) => {
    let storage = window.localStorage.getItem("user");
    storage = storage ? JSON.parse(storage) : null;
    if (storage) window.localStorage.setItem("token", storage.token);

    const [user, setUser] = useState(storage);  

    useEffect(() => {
        if (user) {
            window.sessionStorage.setItem("token", user.token);
        } else {
            window.sessionStorage.removeItem("token");
            window.localStorage.removeItem("user");
        }
    }, [user]);
    
    return <UserContext.Provider value={[user, setUser]}>{props.children}</UserContext.Provider>
};

export { UserContext, UserProvider };